import { render, staticRenderFns } from "./CheckpointMicrolearningTabs.vue?vue&type=template&id=7562eedb&scoped=true"
import script from "./CheckpointMicrolearningTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointMicrolearningTabs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointMicrolearningTabs.vue?vue&type=style&index=0&id=7562eedb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7562eedb",
  null
  
)

export default component.exports